export default class Registration {

	buttonClass = 'woocommerce-form-register__submit';

	constructor() {
		document.getElementsByClassName(this.buttonClass).forEach((el) => {
			el.addEventListener('click', (e) => {
				el.setAttribute('disabled', '');
				el.textContent = 'Submitting...'
			});
		});
	}
}
